import { useState } from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';
import FeatureComparisonHeader from './FeatureComparisonHeader';
import FeatureCategory from './FeatureCategory';

interface Feature {
  name: string;
  description?: string;
  starter: any;
  max: any;
  family: any;
}

interface FeatureCategoryData {
  name: string;
  icon?: string;
  features: Feature[];
}

interface FeatureComparisonProps {
  featureCategories: FeatureCategoryData[];
  freePlan?: any;
}

const FeatureComparison = ({ featureCategories, freePlan }: FeatureComparisonProps) => {
  const [expandedSections, setExpandedSections] = useState<Set<string>>(
    new Set(['Resources & Education', 'Personal Dashboard & Planning', 'Home Safety & Independence'])
  );

  const toggleSection = (categoryName: string) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(categoryName)) {
      newExpanded.delete(categoryName);
    } else {
      newExpanded.add(categoryName);
    }
    setExpandedSections(newExpanded);
  };

  const toggleAllSections = () => {
    const allExpanded = featureCategories.every(cat => expandedSections.has(cat.name));
    if (allExpanded) {
      setExpandedSections(new Set());
    } else {
      setExpandedSections(new Set(featureCategories.map(cat => cat.name)));
    }
  };

  const allExpanded = featureCategories.every(cat => expandedSections.has(cat.name));

  return (
    <TooltipProvider>
      <div id="feature-comparison" className="mb-16">
        <FeatureComparisonHeader 
          onToggleAll={toggleAllSections}
          allExpanded={allExpanded}
        />
        <div className="space-y-6">
          {featureCategories.map((category) => (
            <FeatureCategory
              key={category.name}
              category={category}
              isExpanded={expandedSections.has(category.name)}
              onToggle={toggleSection}
            />
          ))}
        </div>
      </div>
    </TooltipProvider>
  );
};

export default FeatureComparison;
